import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";
import NoAccess from "../pages/NoAccess";
import {
  canAccessTenantAdmin,
  getRoleNames,
  hasAnyPermission,
} from "../utils/tenantAdminAccess";

export default function TenantAdminAccessRoute({ children, requiredAnyPermissions = [] }) {
  const { user, loading } = useUser();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="p-4 rounded shadow bg-white">Laden...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const pathname = String(location.pathname || "");
  if (user?.forcePasswordReset === true && pathname !== "/wachtwoord-reset") {
    return <Navigate to="/wachtwoord-reset" replace />;
  }

  if (!canAccessTenantAdmin(user)) {
    const roleNames = getRoleNames(user);
    const visibleRole = roleNames[0] || user?.rol || user?.role || "";
    return (
      <NoAccess
        allowedRoles={["TenantAdmin", "Projectleider (met tenantbeheerrechten)"]}
        currentRole={visibleRole}
        requiredRoles={["TenantAdmin", "Projectleider (met tenantbeheerrechten)"]}
        userRole={visibleRole}
      />
    );
  }

  const roleNames = new Set(getRoleNames(user));
  const isFullTenantAdminAccess =
    roleNames.has("tenantadmin") || roleNames.has("platformadmin");
  const needsRoutePermission =
    Array.isArray(requiredAnyPermissions) && requiredAnyPermissions.length > 0;

  if (
    !isFullTenantAdminAccess &&
    needsRoutePermission &&
    !hasAnyPermission(user, requiredAnyPermissions)
  ) {
    return (
      <NoAccess
        allowedRoles={["TenantAdmin", "Projectleider (met specifieke tenantbeheerrechten)"]}
        currentRole={Array.from(roleNames)[0] || user?.rol || user?.role || ""}
        requiredRoles={["TenantAdmin", "Projectleider (met specifieke tenantbeheerrechten)"]}
        userRole={Array.from(roleNames)[0] || user?.rol || user?.role || ""}
      />
    );
  }

  return children;
}
